'use client'

import {
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices
} from '@/types'
import { memo } from 'react'

import { Comment, OpeningSection, WeekDay } from '@/types/typo3/openings'
import Richtext from '@/ui/components/Base/Richtext'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data:
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityEventList
}

const SpotSanityDetailOpeningHours = ({ data }: Props) => {
  const getVariant = (): 'event' | 'default' => {
    switch (data.type) {
      case 'spotsanity_eventlist':
        return 'event'
      default:
        return 'default'
    }
  }

  if (getVariant() === 'event') {
    return null
  }

  const listOfOpeningHours = data?.content?.item?.listOfOpeningHours?.items

  return (
    <div className="gap-xl grid grid-cols-1">
      {listOfOpeningHours?.map((item: OpeningSection, i: number) => (
        <div
          key={i?.toString()}
          className="textstyle-md-regular text-neutral-600"
        >
          <div className="mb-sm textstyle-md-bold">{item?.title}</div>
          {item?.weekDays?.map((day: WeekDay, index: number) => (
            <div key={index?.toString()}>
              {day?.nameDay && day?.nameDay?.substring(0, 2)}: {day?.text}
            </div>
          ))}

          {item?.comments && item?.comments?.length > 0 && (
            <div className="mt-sm">
              {item?.comments?.map((comment: Comment, index: number) => (
                <Richtext key={index?.toString()} text={comment?.text} />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default memo(SpotSanityDetailOpeningHours)
